import React from 'react';
import { Space } from '@sravni/react-design-system/lib/Space';
import { useIsMobile } from '@sravni/react-utils';
import { Copyrights } from './Copyrights.js';
import { Socials } from './Socials.js';

const FooterBottom = ({ socialLinks, className, ...rest }) => {
    const isMobile = useIsMobile();
    return (React.createElement(Space, { size: [32, 16], direction: isMobile ? 'column' : 'row', align: "flex-start", className: className, wrap: true, ...rest },
        React.createElement(Copyrights, null),
        React.createElement(Socials, { socialLinks: socialLinks })));
};
FooterBottom.displayName = 'FooterBottom';

export { FooterBottom };
//# sourceMappingURL=FooterBottom.js.map
